module.exports = __webpack_public_path__ + "static/15-bd357279161c9c38acee5017b5258583.jpg";